export default class SiteCountrySwitcher {
    constructor() {
        $('.js-site-switcher-item').on('click', function clickHandle() {
            const data = $(this).data();
            if (window.location.href.indexOf(data.href) >= 0) {
                if (CLOROX_GLOBAL.cacheByCountry) {
                    $.cookie('STYXKEY-country', data.country.toUpperCase(), {
                        path: '/',
                        secure: true,
                        domain: window.location.host,
                    });
                }
                window.location.reload();
            } else {
                // switch to new site
                window.location.href = data.href;
            }
            return false;
        });
    }
}
